import { NgModule, inject } from '@angular/core';
import { provideApollo } from 'apollo-angular';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';

import { environment } from 'environments/environment';

export const createApolloProvider = () => {
    return provideApollo(() => {
        const namedOperationsLink = new ApolloLink((operation, forward) => {
            const uri = environment.baseGraphQlUrl;

            const { operationName } = operation;
            const contextUri = `${uri}/graphql${operationName ? `?o=${operationName}` : ''}`;

            const context = operation.getContext();

            operation.setContext({ ...context, uri: contextUri });

            return forward(operation);
        });

        const http = inject(HttpLink).create({ uri: environment.baseGraphQlUrl });

        return {
            cache: new InMemoryCache({ resultCaching: false }),
            defaultOptions: {
                query: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
            },
            connectToDevTools: !environment.production,
            link: ApolloLink.from([namedOperationsLink, http]),
        };
    });
};

@NgModule({
    providers: [createApolloProvider()],
})
export class GraphQLModule { }
